import fetch from 'auth/GenericFetchInterceptor'

const ProvenienzeService = {}


ProvenienzeService.getProvenienze = function () {
    return fetch({
        url: `/api/sources`,
        method: 'GET'
    })
}

ProvenienzeService.inserisciProvenienza = function (data) {
    return fetch({
        url: `/api/sources`,
        method: 'POST',
        data:data
    })
}
ProvenienzeService.deleteProvenienza = function (id) {
    return fetch({
        url: `/api/sources/${id}`,
        method: 'DELETE',
    })
}
ProvenienzeService.modificaProvenienza = function (id,data) {
    return fetch({
        url: `/api/sources/${id}`,
        method: 'PUT',
        data:data
    })
}

ProvenienzeService.modificaCategoriaProvenienza = function (data) {
    return fetch({
        url: `/api/modifica-categoria-provenienza`,
        method: 'PUT',
        data:data
    })
}
export default ProvenienzeService;